import React from 'react'
import classNames from 'classnames'

import style from './TmoSvg.module.css'

function TmoSvg({ className, svgId, onClick, ...rest }) {
  const svgProps = {
    className: classNames(style.container, className),
    onClick: onClick
  }

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      onClick()
    }
  }

  if (onClick) {
    svgProps.role = 'button'
    svgProps.tabIndex = '0'
    svgProps.onKeyDown = handleKeyDown
  }

  return (
    <svg {...svgProps} {...rest}>
      <use href={`#${svgId}`} xlinkHref={`#${svgId}`} />
    </svg>
  )
}

export default TmoSvg
